(function() {
  if (window._detailsdisclosureLoaded) return;
  window._detailsdisclosureLoaded = true;

function _optionalChain$1(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i];
    const fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }

  return value;
}

if (!customElements.get('details-disclosure')) {
  class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');

      _optionalChain$1([
        this,
        'access',
        (_) => _.mainDetailsToggle,
        'optionalAccess',
        (_2) => _2.addEventListener,
        'call',
        (_3) => _3('focusout', this.onFocusOut.bind(this)),
      ]);
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    close() {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
    }
  }
}

function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i];
    const fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }

  return value;
}

class ShareButton extends DetailsDisclosure {
  constructor() {
    super();

    this.elements = {
      shareButton: this.querySelector('button'),
      shareSummary: this.querySelector('summary'),
      closeButton: this.querySelector('.share-button__close'),
      successMessage: this.querySelector('[id^="ShareMessage"]'),
      urlInput: this.querySelector('input'),
    };
    this.urlToShare = this.elements.urlInput
      ? this.elements.urlInput.value
      : document.location.href;

    if (navigator.share) {
      if (this.mainDetailsToggle) {
        this.mainDetailsToggle.setAttribute('hidden', '');
      }
      _optionalChain([
        this,
        'access',
        (_) => _.elements,
        'access',
        (_2) => _2.shareButton,
        'optionalAccess',
        (_3) => _3.classList,
        'access',
        (_4) => _4.remove,
        'call',
        (_5) => _5('hidden'),
      ]);
      _optionalChain([
        this,
        'access',
        (_6) => _6.elements,
        'access',
        (_7) => _7.shareButton,
        'optionalAccess',
        (_8) => _8.addEventListener,
        'call',
        (_9) =>
          _9('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          }),
      ]);
    } else {
      this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
      _optionalChain([
        this,
        'access',
        (_10) => _10.mainDetailsToggle,
        'access',
        (_11) => _11.querySelector,
        'call',
        (_12) => _12('.share-button__copy'),
        'optionalAccess',
        (_13) => _13.addEventListener,
        'call',
        (_14) => _14('click', this.copyToClipboard.bind(this)),
      ]);
      _optionalChain([
        this,
        'access',
        (_15) => _15.mainDetailsToggle,
        'access',
        (_16) => _16.querySelector,
        'call',
        (_17) => _17('.share-button__close'),
        'optionalAccess',
        (_18) => _18.addEventListener,
        'call',
        (_19) => _19('click', this.close.bind(this)),
      ]);
    }
  }

  toggleDetails() {
    if (!this.mainDetailsToggle.open) {
      _optionalChain([
        this,
        'access',
        (_20) => _20.elements,
        'access',
        (_21) => _21.successMessage,
        'optionalAccess',
        (_22) => _22.classList,
        'access',
        (_23) => _23.add,
        'call',
        (_24) => _24('hidden'),
      ]);
      this.elements.successMessage && (this.elements.successMessage.textContent = '');
      _optionalChain([
        this,
        'access',
        (_25) => _25.elements,
        'access',
        (_26) => _26.closeButton,
        'optionalAccess',
        (_27) => _27.classList,
        'access',
        (_28) => _28.add,
        'call',
        (_29) => _29('hidden'),
      ]);
      _optionalChain([
        this,
        'access',
        (_30) => _30.elements,
        'access',
        (_31) => _31.shareSummary,
        'optionalAccess',
        (_32) => _32.focus,
        'call',
        (_33) => _33(),
      ]);
    }
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
      _optionalChain([
        this,
        'access',
        (_34) => _34.elements,
        'access',
        (_35) => _35.successMessage,
        'optionalAccess',
        (_36) => _36.classList,
        'access',
        (_37) => _37.remove,
        'call',
        (_38) => _38('hidden'),
      ]);
      this.elements.successMessage &&
        (this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess);
      _optionalChain([
        this,
        'access',
        (_39) => _39.elements,
        'access',
        (_40) => _40.closeButton,
        'optionalAccess',
        (_41) => _41.classList,
        'access',
        (_42) => _42.remove,
        'call',
        (_43) => _43('hidden'),
      ]);
      _optionalChain([
        this,
        'access',
        (_44) => _44.elements,
        'access',
        (_45) => _45.closeButton,
        'optionalAccess',
        (_46) => _46.focus,
        'call',
        (_47) => _47(),
      ]);
    });
  }
}

if (!customElements.get('share-button')) {
  customElements.define('share-button', ShareButton);
}

})();